import React, { useState } from 'react'
import { Table, TableComponent } from 'components/Table'

export default function FormasEnvio() {
  const [TableData] = useState(
    Table.Data([
      Table.Field('DESCRIPCION', 'Descripción'),
      Table.Field('COSTOENVIO', 'Costo de envío'),
      Table.Field('tipo_envio', 'Tipo de envío'),
    ], [
      ...Table.DefaultActions(),
    ],
      Table.Config('forma-envio', 'DESCRIPCION', 'IDENVIO')
    )
  )
  
  return (
    <div>
      <h2>Formas de Envio</h2>
      <TableComponent
        data={TableData}
      />
    </div>
  )
}
